import '@descope-ui/descope-combo-box';
import '@descope-ui/descope-text-field';

import PhoneFieldInternal, { componentName } from './PhoneFieldInternal';

customElements.define(componentName, PhoneFieldInternal);
